/**
 * equasion-lib's .d.ts types `Button` without `onClick` and `Input` with every prop required,
 * although both forward the rest to the DOM element at runtime. Spreading an untyped bag keeps
 * this screen from adding to the app's standing TS2322 baseline.
 */
export const eqProps = (props: Record<string, unknown>): any => props;
